import { Divider } from "@mui/material";

import { GroupInfo } from "./GroupInfo";
import { GroupPrivacy } from "./GroupPrivacy";
import { GroupMembers } from "./GroupMembers";

export const GroupFormFields = () => {
  return (
    <>
      <GroupInfo />
      <Divider orientation="horizontal" sx={{ border: "1px solid var(--Dark---200, #E0E0E0)", width: "100%" }} />
      <GroupPrivacy />
      <Divider orientation="horizontal" sx={{ border: "1px solid var(--Dark---200, #E0E0E0)", width: "100%" }} />
      <GroupMembers />
    </>
  );
};

export default GroupFormFields;
